import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import complex from '~root/src/components/complex.vue?shadow'
window.customElements.define('searchbooster-complex', wrap(Vue, complex))

import searchPopup from '~root/src/components/search-popup.vue?shadow'
window.customElements.define('searchbooster-search-popup', wrap(Vue, searchPopup))